/* eslint-disable max-len */
import React, { useState } from 'react';
import { TableCell, TableRow } from '@mui/material';

// COMPONENTS
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';

// REDUX

import * as SP from '../styles';
import * as S from './styles';
import { getTranslateByKey } from '@/main/services/utils';
import { InsurerBySupervisorResponse } from '@/main/models/response/supervisorResponse';
import InsurerCompanySidebar from './insurerCompanySidebar';
import { Close } from '@mui/icons-material';
import { supervisorApi } from '@/main/api';
import LoadingComponent from '../loading/loadingComponent';
import { toast } from 'react-toastify';
import { KeyValue } from '@/main/models/common';
import useAsyncModalConfirmReason from '@/main/components/shared/asyncModalConfirmReason/asyncModalConfirmReason';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';
import { toBase64 } from '@/main/services/utilsFile';

interface IInsurerCompanyProps {
  dataInsurerCompany: InsurerBySupervisorResponse[];
  guidSupervisor: string;
  refreshData: () => void;
}

function InsurerCompany({
  dataInsurerCompany,
  guidSupervisor,
  refreshData
}: IInsurerCompanyProps) {
  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [getConfirmationReason, ModalConfirmationReason] = useAsyncModalConfirmReason();

  function closeModal() {
    setOpen(false);
  }

  async function handleDeleteInsurer(insurerGuid: string) {
    let resultConfirm = null;
    let filesRequest = undefined;

    resultConfirm = await getConfirmationReason(
      getTranslateByKey('information.confirmChangeTitle'),
      ReasonTypeEnum.ChangeCompany
    );
    if (!resultConfirm.confirmed) return;

    if (resultConfirm.files && resultConfirm.files.length > 0) {
      filesRequest = await Promise.all(
        resultConfirm.files.map(async item => {
          const base64DataUrl = await toBase64(item);
          return {
            fileName: item.name,
            contentType: item.type,
            fileBase64: base64DataUrl as string
          };
        })
      );
    }

    setIsLoading(true);

    const request = {
      guidSupervisorInsurer: insurerGuid,
      changeJustification: {
        guidReason: resultConfirm?.reason ? String(resultConfirm.reason.key) : null,
        reasonDescription: resultConfirm?.observation || null,
        filesUpload: filesRequest
      }
    };

    supervisorApi
      .inactiveInsurerBySurpervisor(request)
      .then(() => {
        toast.success(
          getTranslateByKey('information.supervisorEditSuccessfully')
        );
        refreshData();
      })
      .catch(error => {
        error.errorMessages.forEach((e: KeyValue) => {
          toast.error(e.value);
        });
      })
      .finally(() => setIsLoading(false));
  }

  return (
    <>
      <S.Container id="id-register-insurer-company">
        <SP.HeaderSection>
          <SP.HeaderText>
            {getTranslateByKey('information.insurer')}
          </SP.HeaderText>
          <SecondaryButton
            id="id-register-btn-addInsurer"
            type="button"
            onClick={() => setOpen(true)}
            style={{ padding: '.2rem .8rem', margin: '.5rem 0 0 .8rem' }}>
            {getTranslateByKey('information.add')}
            {` ${getTranslateByKey('information.insurer').toLowerCase()}`}
          </SecondaryButton>
        </SP.HeaderSection>

        {dataInsurerCompany.length > 0 && (
          <BoxGrid
            marginCustom='0.7rem 0 0 0'
            rowHeaders={[
              getTranslateByKey('information.insurerCompany'),
              getTranslateByKey('information.actions')
            ]}>
            {dataInsurerCompany.map(insurer => (
              <TableRow key={insurer.guidSupervisor_Insurer}>
                <TableCell>{insurer.insurerCompanyName}</TableCell>
                <TableCell width="5%">
                  {isLoading ? (
                    <LoadingComponent size={10} />
                  ) : (
                    <Close
                      onClick={() =>
                        handleDeleteInsurer(insurer.guidSupervisor_Insurer)
                      }
                      id={
                        'id-register-icon-delete-' +
                        insurer.guidSupervisor_Insurer
                      }
                      className="cursor-pointer"
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </BoxGrid>
        )}
      </S.Container>

      <InsurerCompanySidebar
        open={open}
        closeModal={closeModal}
        guidSupervisor={guidSupervisor}
        loadGridList={refreshData}
      />
      <ModalConfirmationReason closeByOverlay={false} />
    </>
  );
}

export default InsurerCompany;
